module.exports = __webpack_public_path__ + "img/04.b19debe7.jpg";